import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CouponViewState, ParameterService, PaymentService, SpinnerComponent } from '@frontend/frontendlib';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SpinnerComponent
  ]
})
export class CouponComponent implements OnInit {
  coupon_code = '';
  loading = false;
  state = 0;
  resp = {} as any;
  CouponViewStateEnum: typeof CouponViewState = CouponViewState;

  private paymentService = inject(PaymentService);
  public parameterService = inject(ParameterService);

  ngOnInit(): void {
    this.loading = false;
    this.state = CouponViewState.ShowCodeEntry;
  }

  einloesen() {
    this.loading = true;
    this.paymentService.couponInfo(
      this.parameterService.queryParams.channel_id,
      this.parameterService.queryParams.payment_id ?? '',
      this.coupon_code
    )
    .subscribe((val) => {
      this.state = val.amount * 1 > 0 ? 2 : 3;
      if (val.error * 1 === 23 && val.openamount * 1 > 0) {
        this.resp = val;
        this.resp.amount = val.openamount;
        this.state = CouponViewState.ShowValue;
      }
      else {
        this.resp = val;
      }
      this.loading = false;
    });
  }

  add_to_paymentlist() {
    this.loading = true;
    this.paymentService.couponCashing(
      this.parameterService.queryParams.channel_id,
      this.parameterService.queryParams.payment_id ?? '',
      this.coupon_code
    )
    .subscribe((val) => {
      this.resp = val;
      if ((val.error ?? 1) * 1 === 0) {
        this.parameterService.load_data();
        this.parameterService.$fininishedLoading.subscribe((val) => {
          if (val) {
            this.parameterService.init_state();
          }
        });
      } else {
        this.state = CouponViewState.CashingError;
      }
      this.loading = false;
    });
  }

  cancel() {
    this.parameterService.coupon_input = false;
    this.state = CouponViewState.ShowCodeEntry;
    this.coupon_code = '';
  }
}
